module.exports = __webpack_public_path__ + "media/images/flavours/icon-gourmand_dark-503f2dd71a4076fca1ec6172231bc08e.png";